import type { ActivityModule } from '../../core/activity';
import { runVerticalActivity, filterLaidLevels } from '../../shared/vertical-runner';
import levelsData from './levels.json';
import '../vertical_subtraction/style.css';

const LEVELS = filterLaidLevels(levelsData.levels);

export const verticalSubtractionCompensation: ActivityModule = {
  id: 'vertical_subtraction_compensation',
  title: 'Subtração por compensação',
  description: 'Subtração armada usando o método da compensação: quando o de cima é menor, soma 10 em cima e +1 embaixo na próxima coluna.',
  ageMin: 8,
  ageMax: 11,
  difficulty: 4,
  iconPath: 'assets/gcompris-AGPL/vertical_subtraction_compensation/icon.svg',
  category: 'aritmetica',
  totalLevels: LEVELS.length,
  mount: (ctx) => runVerticalActivity(ctx, {
    operation: 'minus',
    title: 'Subtração por compensação',
    activityId: 'vertical_subtraction_compensation',
    levels: LEVELS,
  }),
};
